// Formats français partagés par tous les écrans.
const fmtEur = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
const fmtNombre = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 1 });

export function eur(v) {
  const n = typeof v === 'number' ? v : parseFloat(v);
  return Number.isFinite(n) ? fmtEur.format(n) : '—';
}

export function km(v) {
  const n = typeof v === 'number' ? v : parseFloat(v);
  return Number.isFinite(n) ? `${fmtNombre.format(n)} km` : '';
}

// Jour calendaire ('AAAA-MM-JJ' ou ISO) → 'JJ/MM/AAAA', SANS passer par un
// objet Date : new Date('2026-07-07') est minuit UTC, soit la veille au soir
// aux Antilles — l'écart d'un jour vient de là.
export function dateFr(v) {
  if (!v) return '';
  const s = String(v).slice(0, 10);
  const [a, m, j] = s.split('-');
  return a && m && j ? `${j}/${m}/${a}` : s;
}
